import { ArrowBack } from '@mui/icons-material';
import { IconButton, Container, Typography, Box } from '@mui/material';
import React from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import Analytics from './Analytics';
import IndividualCompDetail from './IndividualCompDetail';
import CompetitionEntries from './CompetitionEntries';
import Activities from './Activities';
import NotificationScheduler from './NotificationScheduler';


const ParticipateList = () => {
  const navigate = useNavigate();
  const { competition_id } = useParams();
  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ mt: { xs: 3, sm: 3, md: 0 }, mb: { xs: 3, sm: 3, md: 0 }, }} disableGutters>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <IconButton edge="start" color="inherit" onClick={() => navigate('/competitions')}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" component="div" sx={{ ml: 1 }}>
          Competition Details
        </Typography>
      </Box>


        <Analytics competitionId={competition_id} />
        <IndividualCompDetail competitionId={competition_id} />
        <CompetitionEntries competitionId={competition_id} />
        <NotificationScheduler competitionId={competition_id} />
        <Activities competitionId={competition_id} />

      </Container>
    </React.Fragment>
  )
}

export default ParticipateList